import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import 'scrolltofixed';
import 'slick-carousel';

import OneProductForm from '@/modules/module-oneProductForm';
import OneZoom from '@/modules/module-oneZoom';
import OneDrawer from '@/modules/module-oneDrawer';
import OneTabSystem from '@/modules/module-oneTabSystem';
import OneVideo from '@/modules/module-oneVideo';
import OneRecentlyViewed from '@/modules/module-oneRecentlyViewed';
import OneMarketing from '@/modules/module-oneMarketing';

import '../../styles/modules/oneSizeChart.scss';
import { PUB_SUB_EVENTS, subscribe } from '@/lib/pubsub';

// Bind the popstate listener exactly once per page load.
var popstateBound = false;

export default Backbone.View.extend({
    
    initialize: function(opts){

        console.log('init PDP');

        var self = this

        // `isReinit: true` is set by loadLinkedProduct when re-creating the view
        // after an AJAX swatch swap. Modules that live OUTSIDE .product-detail-container
        // (testimonials, results slider, recently viewed, accordions) must skip setup
        // on re-init — their DOM wasn't replaced and double-init crashes slick/tabs.
        self._opts = opts || {};
        var isReinit = self._opts.isReinit === true;

        // Cleanup handles (consumed by destroy())
        self._unsubscribers = [];
        self._productFormView = null;

        // $content is <body>
        self.$content = self.$el;
        self.$detailContainer = self.$content.find('.product-detail-container');
        
        self.$media = self.$content.find('.product-media');
        self.$mainImage = self.$media.find('#ProductMediaImages');
        self.$thumbImage = self.$media.find('#ProductMediaThumbs');
        self.$mediaSlider = self.$mainImage.find('.images-wrapper');

        self.$testimonialsModule = self.$content.find('.testimonials-module');

        self.$productCore = self.$content.find('.product-core');
        self.$socialIcons = self.$productCore.find('.one-social');
        self.isGiftCard = self.$detailContainer.hasClass('gift-card');
        self.productQty = self.$content.find('.product-qty-container');
        self.productCrossSell = self.$content.find('.block-cross-sell');

        self.$recentlyViewed = self.$content.find('.recently-viewed .items');
        
        // Features
        self.enableMiniCore = false;
        self.isScrollingLayout = self.$content.data('layout') == 'scrolling' ? true : false;
        self.isScrollingGrid = self.$content.hasClass('scrolling-grid');
        self.isSliderLayout = self.$content.data('layout') == 'slider' ? true : false;
        self.isQuickshopLayout = self.$content.data('layout') == 'quickshop' ? true : false;
        
        if (ORW.enableGTM) {
            ORW.marketing = ORW.marketing || new OneMarketing;
        }

        self.$testimonialsModule.length > 0 && _.each(self.$testimonialsModule, (module) => {
            self.testimonialsModule($(module));
        })

        self.productCore();
        self.initPrice();
        self.initPiecesPerPack();

        if (!self.isGiftCard) {
            self.productMedia();
        }

        if (!self.isQuickshopLayout) {
            self.social();
            if (ORW.enableGTM) {
                ORW.marketing.viewItem(self.$productCore);
            }
        }

        if (!self.isGiftCard && !self.isQuickshopLayout) {
            self.zoom();
            self.video();
            // self.sizeChart();
            if (!isReinit) self.accordionsAndTabs();
            if (!isReinit) self.recentlyViewed();
            if (!isReinit) self.resultsSlider();
            self.sizeGuideScroll();
            self.colorNameHover();
            self.restoreSwatchView();
        }

        // Must run before OneProductForm.init — its updateURL() does
        // replaceState({}, ...) which wipes history.state.linkedSwatch.
        self.bindPopstate();

        self._productFormView = OneProductForm.init({
            el: self.el.querySelector('form.add-to-cart-form'),
            preSelect: self.isQuickshopLayout,
            updateURL: !self.isQuickshopLayout,
        });
    },

    events: {
        'click .swatch-linked:not(.quick-shop-trigger-link)': 'onLinkedSwatchClick',
        'click [data-swatch-view-toggle] .swatch-view-toggle__btn': 'onSwatchViewToggle',
        'click .swatch-notify-me': 'onNotifyMeClick'
    },
    
    productMedia: function(){
        var self = this;
        var events = {
            'click .image-thumbnail' : function(e){
                e.preventDefault();
                var $curr = $(e.currentTarget);
                var index = $curr.data('index') - 1;
                if (self.$media.hasClass('initialized')) {
                    self.$mediaSlider.slick('slickGoTo',index);
                }
            }
        }
        
        self.$mediaSlider.on('init', function(event, slick, direction){
            self.$media.addClass('initialized');
            $(window).resize();
        });
        self.$mediaSlider.slick({
            dots: false,
            infinite: true,
            speed: 600,
            slidesToShow: 1,
            arrows: false,
            rows: 0
        });
        
        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();

        // Main Slick slider
        const $imageSlider = this.$el.find('.product-media-images .images-wrapper');
        const imageMain = $imageSlider[0]; // JS element object same as $imageSlider[0]
        // Thumb Images
        const imageThumbs = this.el.querySelector('.product-media-thumbnails .images-wrapper');

        // Check if image elements have more than one value. If not, don't initialize
        const imageVariantValues = new Set(
            [...imageThumbs.querySelectorAll('[data-variant-option-value]')]
            .map(el => el.dataset.variantOptionValue)
            .filter(Boolean) // Remove empty values
        );
        if (imageVariantValues.size <= 1) return;

        const unsubscribeVariantOptions = subscribe(PUB_SUB_EVENTS.variantOptionsChange, (options) => {

            const filterSelector = options.map(option => `[data-variant-option-value="${ORW.utilities.handleize(option)}"]`).join(',');

            // Maybe no option selected yet
            if (!filterSelector) return

            // Update Main Slick slider (need to do unfilter first to bring back the filtered out slides from previous filter)
            $imageSlider.slick('slickUnfilter');
            const preFilterCheck_main = imageMain.querySelectorAll(filterSelector);
            if (preFilterCheck_main.length === 0) return
            $imageSlider.slick('slickFilter', filterSelector);

            // Update Thumb Images
            const preFilterCheck_thumbs = imageThumbs.querySelectorAll(filterSelector);
            if (preFilterCheck_thumbs === 0) return
            imageThumbs.querySelectorAll('.image-thumbnail').forEach(el => {
                el.hidden = true;
            });
            preFilterCheck_thumbs.forEach(el => {
                el.hidden = false
            });
        });
        self._unsubscribers.push(unsubscribeVariantOptions);
    },

    initPrice: function() {
        var self = this;
        const priceBox = this.el.querySelector('.product-detail-container .price-box');
        if (!priceBox) return;

        const fmt = (v) => Shopify.formatMoney(v, window.theme.moneyFormat);
        const isPro = priceBox.classList.contains('has-pro-price');
        const discountPercent = parseFloat(priceBox.dataset.proDiscountPercent || '0');
        const retailLabel = priceBox.dataset.retailLabel || 'Retail';
        const saleLabel = priceBox.dataset.saleLabel || 'Sale';
        const saveTemplate = priceBox.dataset.saveTemplate || 'You save __AMOUNT__';
        const percentTemplate = priceBox.dataset.percentTemplate || '__PERCENT__% off';

        const savingsEl = priceBox.querySelector('.price-savings');
        const savingsAmountEl = savingsEl ? savingsEl.querySelector('.savings-amount') : null;
        const savingsPercentEl = savingsEl ? savingsEl.querySelector('.savings-percent') : null;

        // Savings vs. retail: retail minus the price this shopper actually pays.
        const updateSavings = (retail, effective) => {
            if (!savingsEl) return;
            const savings = retail - effective;
            if (retail > 0 && savings > 0) {
                if (savingsAmountEl) savingsAmountEl.textContent = saveTemplate.replace('__AMOUNT__', fmt(savings));
                if (savingsPercentEl) savingsPercentEl.textContent = percentTemplate.replace('__PERCENT__', Math.round(savings / retail * 100));
                savingsEl.hidden = false;
            } else {
                savingsEl.hidden = true;
            }
        };

        const labelSpan = (text) => `<span class="price-label">${text}</span>`;
        const valueSpan = (text) => `<span class="price-value">${text}</span>`;

        const unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, (variant) => {
            const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
            const retail = onSale ? variant.compare_at_price : variant.price;

            if (isPro && discountPercent > 0) {
                const proPrice = Math.round(variant.price * (100 - discountPercent) / 100);
                const proEl = priceBox.querySelector('.pro-price');

                let compareEl = priceBox.querySelector('.product-compare-price');
                let regularEl = priceBox.querySelector('.regular-price');
                let saleEl = priceBox.querySelector('.sale-price');

                if (onSale) {
                    // Sale + pro: struck retail price, normal sale price, then pro price on its own line.
                    if (regularEl) { regularEl.remove(); regularEl = null; }
                    if (!compareEl) {
                        compareEl = document.createElement('span');
                        compareEl.className = 'body-font-1 product-compare-price';
                        priceBox.insertBefore(compareEl, proEl);
                    }
                    compareEl.innerHTML = `${labelSpan(retailLabel)} ${valueSpan(fmt(variant.compare_at_price))}`;
                    if (!saleEl) {
                        saleEl = document.createElement('span');
                        saleEl.className = 'body-font-1 product-price sale-price';
                        saleEl.setAttribute('itemprop', 'price');
                        priceBox.insertBefore(saleEl, proEl);
                    }
                    saleEl.setAttribute('content', (variant.price / 100).toFixed(2));
                    saleEl.innerHTML = `${labelSpan(saleLabel)} ${valueSpan(fmt(variant.price))}`;
                } else {
                    // Pro, no sale: single plain retail price, then pro price.
                    if (compareEl) compareEl.remove();
                    if (saleEl) { saleEl.remove(); saleEl = null; }
                    if (!regularEl) {
                        regularEl = document.createElement('span');
                        regularEl.className = 'body-font-1 product-price regular-price';
                        regularEl.setAttribute('itemprop', 'price');
                        priceBox.insertBefore(regularEl, proEl);
                    }
                    regularEl.setAttribute('content', (variant.price / 100).toFixed(2));
                    regularEl.innerHTML = `${labelSpan(retailLabel)} ${valueSpan(fmt(variant.price))}`;
                }

                if (proEl) {
                    const label = proEl.dataset.label || 'Your Pro Price';
                    proEl.innerHTML = `${labelSpan(label)} ${valueSpan(fmt(proPrice))}`;
                }

                updateSavings(retail, proPrice);
                return;
            }

            const priceEl = priceBox.querySelector('.product-price');
            if (priceEl) priceEl.textContent = fmt(variant.price);

            let compareEl = priceBox.querySelector('.product-compare-price');
            if (onSale) {
                if (!compareEl) {
                    compareEl = document.createElement('span');
                    compareEl.className = 'body-font-1 product-compare-price';
                    priceEl.parentNode.insertBefore(compareEl, priceEl);
                }
                compareEl.textContent = fmt(variant.compare_at_price);
            } else if (compareEl) {
                compareEl.remove();
            }

            updateSavings(retail, variant.price);
        });
        self._unsubscribers.push(unsubscribeVariantChange);
    },

    initPiecesPerPack: function() {
        var self = this;
        const labelEl = this.el.querySelector('.product-detail-container .pieces-per-pack');
        if (!labelEl) return;

        const mapEl = this.el.querySelector('.product-detail-container [data-pieces-per-pack-map]');
        if (!mapEl) return;

        let piecesMap = {};
        try {
            piecesMap = JSON.parse(mapEl.textContent);
        } catch (e) {
            return;
        }

        const template = labelEl.dataset.template || '';
        const defaultPieces = labelEl.dataset.default || '';

        const unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, (variant) => {
            const pieces = piecesMap[variant.id] != null ? piecesMap[variant.id] : defaultPieces;
            if (pieces === '' || pieces == null) {
                labelEl.hidden = true;
                return;
            }
            labelEl.hidden = false;
            labelEl.textContent = template.replace('__COUNT__', pieces);
        });
        self._unsubscribers.push(unsubscribeVariantChange);
    },
    
    productCore: function(){
        var self = this;
        self.productQuantity();

        if (self.productCrossSell.length > 0) {
            self.enableProductCrossSell();
        }
        
        if (!self.isQuickshopLayout) {
            if (self.enableMiniCore) {
                self.productCoreMini();
            }
            
            if (self.isScrollingLayout && !self.isScrollingGrid) {
                self.productCoreScrollFixing()
            }
        }
    },
    
    productQuantity: function(){
        var self = this;
        var $input = self.productQty.find('.qty-input[type=number]');
        var qty = $input.data('value');

        var events = {
            'click .product-qty-container .qty-btn' : function(e){
                e.preventDefault();
                var $curr = $(e.currentTarget);
                if($curr.hasClass('plus')){
                    $input[0].stepUp()
                } else {
                    $input[0].stepDown();
                }
                $input.attr('value', $input.val())
            }
        }

        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },

    enableProductCrossSell: function(){
        var self = this;
        const crossSellContainer = self.productCrossSell.get()[0];
        if (!crossSellContainer) return;

        const carousel = crossSellContainer.querySelector('.tab-carousel');
        if (!carousel) return;

        const crossSellProducts = carousel.querySelector('.cross-sell-products');
        const prevArrow = carousel.querySelector('.slick-prev-slide.slick-arrow');
        const nextArrow = carousel.querySelector('.slick-next-slide.slick-arrow');

        $(crossSellProducts).slick({
            arrows: true,
            dots: false,
            infinite: false,
            speed: 600,
            slidesToShow: 1,
            centerMode: false,
            prevArrow: prevArrow,
            nextArrow: nextArrow,
        })
    },

    testimonialsModule: function($module){
        const self = this
        const sectionId = $module.attr(`id`)
        const $container = $module.find(`> .container`)
        const slickOptions = {
            dots: false,
            infinite: false,
            speed: 600,
            slidesToShow: 1,
            arrows: false,
        }

        // Guard against double-init on AJAX re-mount — the testimonials element
        // lives outside .product-detail-container, so it's already slicked from
        // the original page load. Only register Backbone events below.
        if ($container.hasClass('slick-initialized')) {
            const navActionEventKey = `click #${sectionId} .slick-dots-dummy button`
            self.events[navActionEventKey] = e => {
                const $curr = $(e.currentTarget)
                if ($curr.parent().hasClass(`slick-active`)) return
                const goToIndex = $curr.data(`index`)
                $container.slick(`slickGoTo`, goToIndex)
            }
            self.delegateEvents();
            return;
        }

        $container.slick(slickOptions);

        /*
            This module has multiple in-content dummy slider navigation, we need to build sync between the dummy ones and the real one
        */
        $container.on('beforeChange', function(event, slick, currentSlide, nextSlide){
            $container.find(`.slick-dots-dummy li`).map((index, element) => {
                const $el = $(element)
                const $button = $el.find(`button`)
                if ($button.data(`index`) != `${nextSlide}`) {
                    $el.removeClass(`slick-active`)
                    $button.attr(`tabindex`, `-1`).removeAttr(`aria-selected`)
                } else {
                    $el.addClass(`slick-active`)
                    $button.attr({
                        "tabindex": `0`,
                        "aria-selected": `true`
                    })
                }
            })
        });

        const navActionEventKey = `click #${sectionId} .slick-dots-dummy button`
        self.events[navActionEventKey] = e => {
            const $curr = $(e.currentTarget)

            if ($curr.parent().hasClass(`slick-active`)) return

            const goToIndex = $curr.data(`index`)
            $container.slick(`slickGoTo`, goToIndex)
        }
        self.delegateEvents();
    },


    productCoreScrollFixing: function(){
        var self = this;
        var init = function($elm){
            $elm.scrollToFixed({
                zIndex: 2,
                removeOffsets: true,
                dontSetWidth: true,
                marginTop: function(){
                    return $('header.site-header').outerHeight() + 50;
                },
                limit: function() {
                    var limit = $('.scrolling-fix-stopper').offset().top - $(this).height();
                    return limit;
                }
            });
        }
        self.$scrollFixingCore = self.$productCore.find('.product-core-inner');
        // Not available on Mobile.
        ORW.utilities.mediaCheck(function () {
            init(self.$scrollFixingCore);
        }, function () {
            self.$scrollFixingCore.trigger('detach.ScrollToFixed');
        });
    },
    
    productCoreMini: function(){
        var self = this;
        var init = function($elm){
            console.log('init minicore');
            $elm.scrollToFixed({
                zIndex: 2,
                removeOffsets: true,
                dontSetWidth: true,
                triggerAtBottom: true,
                marginTop: function(){
                    return $(this).height()*(-1);
                },
                fixed: function(){
                    $(this).addClass('fixed-core fadeInUp animated');
                },
                unfixed: function() {
                    $(this).removeClass('fixed-core fadeInUp animated');
                }
            });
        }
        self.$miniCore = self.$productCore.find('.block-core');
        // Under scrolling layout, miniCore will only available on Small screen.
        ORW.utilities.mediaCheck(function () {
            self.$miniCore.trigger('detach.ScrollToFixed');
            if (!self.isScrollingLayout || self.isScrollingGrid) {
                init(self.$miniCore);
            }
        }, function () {
            self.$miniCore.trigger('detach.ScrollToFixed');
            init(self.$miniCore);
        });
    },
    
    social: function(){
        var self = this;
        var events = {
            'click .share-title':function(e){
                self.$socialIcons.toggleClass('active');
            },
        };
        
        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },
    
    zoom: function(){
        var self = this;
        OneZoom.init({
            el: self.$media,
            mainImage: self.$mainImage,
            thumbImage: self.$thumbImage
        });
    },
    
    video: function(){
        var self = this;
        var $videos = self.$content.find('.video-wrapper');
        OneVideo.init({
            el: $videos,
            isResponsive: false,
            bgVideo: true,
            autoplay: false
        });
    },
    
    accordionsAndTabs: function(){
        var self = this;
        OneTabSystem.init({
            el: $(`main`)
        });
    },
    
    sizeChart: function() {
        var self = this;
        var sizeChartHtml = $('#SizeChartModal').first().outerHTML;
        $('#SizeChartModal').remove();
        var drawerCtl = OneDrawer.init({
            drawerContent: sizeChartHtml,
            drawerModalId: 'SizeChartDrawerModal',
            triggerEvent: 'click',
            triggerElem: '.size-chart-trigger',
            initCallback: function(){
                OneTabSystem.init({
                    el: $('#SizeChartModal')
                });
            },
            openCallback: function(){},
            closeCallback: function(){},
            events: {}
        });
    },

    recentlyViewed: function() {

        let self = this;

        OneRecentlyViewed.init({
            el: self.$recentlyViewed
        });
    },

    resultsSlider: function() {

        let self = this;
        $('.results .results-slider').slick({
            dots: true,
            arrows: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 5000,
            fade: true,
            speed: 1500,
            rows: 0,
        });
    },

    sizeGuideScroll: function() {
        let self = this;
        let $sizeGuide = self.$content.find('#guides');
        let $sizeGuideLink = self.$content.find('.size-guide');

        $sizeGuideLink.on('click', function(e) {
            e.preventDefault();
            $sizeGuide[0].scrollIntoView({ behavior: 'smooth' });
        });
    },

    colorNameHover: function() {
        let colorName = document.querySelector('.swatch-label-wrapper .swatch-label');
        let colorSwatches = document.querySelectorAll('.swatches .swatch.swatch-linked');
        let originalColor = colorName.textContent;
        let newColor;

        colorSwatches.forEach(target => {
            target.addEventListener('mouseenter', () => {
                newColor = "Color: " + target.getAttribute('data-name');
                colorName.textContent = newColor;
            });
        
            target.addEventListener('mouseleave', () => {
                colorName.textContent = originalColor;
            });
        });
    },

    onSwatchViewToggle: function(e) {
        e.preventDefault();
        var $btn = $(e.currentTarget);
        var view = $btn.data('view'); // 'grid' or 'list'

        var $toggle = $btn.closest('[data-swatch-view-toggle]');
        $toggle.find('.swatch-view-toggle__btn').attr('aria-pressed', 'false');
        $btn.attr('aria-pressed', 'true');

        if (view === 'list') {
            $toggle.addClass('is-list');
        } else {
            $toggle.removeClass('is-list');
        }

        this.$el.find('.swatches.linked').attr('data-view', view);

        try { sessionStorage.setItem('pdp-swatch-view', view); } catch (err) {}
    },

    onNotifyMeClick: function(e) {
        e.preventDefault();
        e.stopPropagation();
    },

    restoreSwatchView: function() {
        var saved;
        try { saved = sessionStorage.getItem('pdp-swatch-view'); } catch (err) { return; }
        if (saved !== 'list' && saved !== 'grid') return;

        var $toggle = this.$el.find('[data-swatch-view-toggle]');
        var $swatches = this.$el.find('.swatches.linked');
        if (!$toggle.length || !$swatches.length) return;

        $swatches.attr('data-view', saved);
        $toggle.find('.swatch-view-toggle__btn').attr('aria-pressed', 'false');
        $toggle.find('[data-view="' + saved + '"]').attr('aria-pressed', 'true');
        if (saved === 'list') {
            $toggle.addClass('is-list');
        } else {
            $toggle.removeClass('is-list');
        }
    },

    onLinkedSwatchClick: function(e) {
        var self = this;
        if (self.isQuickshopLayout) return;

        var $swatch = $(e.currentTarget);
        if ($swatch.hasClass('active') || $swatch.hasClass('disabled')) return;

        var url = $swatch.attr('href');
        if (!url) return;

        e.preventDefault();
        self.loadLinkedProduct(url);
    },

    loadLinkedProduct: function(url) {
        var self = this;

        var $section = self.$detailContainer.closest('.shopify-section');
        var sectionId = $section.length ? ($section.attr('id') || '').replace('shopify-section-', '') : '';

        if (!sectionId) {
            // Can't locate Shopify section wrapper — fall back to a full nav.
            window.location.href = url;
            return;
        }

        self.$detailContainer.addClass('is-loading');

        var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'sections=' + encodeURIComponent(sectionId);

        fetch(fetchUrl)
            .then(response => {
                if (!response.ok) throw new Error('HTTP ' + response.status);
                return response.json();
            })
            .then(data => {
                var html = data && data[sectionId];
                if (!html) throw new Error('section "' + sectionId + '" missing in response');

                var parser = new DOMParser();
                var doc = parser.parseFromString(html, 'text/html');
                var newContent = doc.querySelector('.product-detail-container');
                if (!newContent) throw new Error('.product-detail-container missing in section HTML');

                // DOMParser materializes <noscript> contents as real DOM elements
                // (unlike live-document parsing, which keeps them as text). The form
                // has a <noscript><select name="id"> fallback — left in, it creates a
                // duplicate `name="id"` field frozen at the initial variant, and
                // FormData submits that instead of the live hidden input.
                newContent.querySelectorAll('noscript').forEach(function(n) { n.remove(); });

                return newContent;
            })
            .catch(err => {
                // Only network/parse/section errors reach here — hard-nav as fallback.
                console.error('Linked swatch fetch failed:', err);
                window.location.href = url;
                return null;
            })
            .then(newContent => {
                if (!newContent) return; // fetch failed, hard-nav already in progress

                // Swap + re-init. Errors here must NOT trigger hard-nav (content is
                // already visible to the user); log + continue instead.
                try {
                    var $el = self.$el;
                    self.destroy();
                    self.$detailContainer.replaceWith(newContent);
                    history.pushState({}, '', url);
                    try { sessionStorage.setItem('linkedSwatchUsed', '1'); } catch (e) {}

                    new self.constructor({ el: $el, isReinit: true });
                } catch (initErr) {
                    console.error('Linked swatch re-init failed:', initErr);
                }

                // Reviews.io — re-render star ratings on the new DOM. Global fn
                // may not exist (script not loaded, ad blocker, etc) — swallow.
                try {
                    if (typeof window.reinitialiseRatingSnippet === 'function') {
                        window.reinitialiseRatingSnippet();
                    }
                } catch (reviewsErr) {
                    console.warn('reinitialiseRatingSnippet failed:', reviewsErr);
                }
            });
    },

    bindPopstate: function() {
        if (popstateBound) return;
        popstateBound = true;

        // sessionStorage survives reloads (unlike module vars) and can't be wiped
        // by third-party scripts doing replaceState (unlike history.state). Once a
        // swatch AJAX swap has happened in this tab, every popstate on a product
        // page triggers a reload so back/forward always shows the correct product.
        window.addEventListener('popstate', function() {
            try {
                if (sessionStorage.getItem('linkedSwatchUsed')) {
                    window.location.reload();
                }
            } catch (e) {}
        });
    },

    destroy: function() {
        var self = this;

        // Unsubscribe pubsub — critical, otherwise stale callbacks fire on detached DOM.
        (self._unsubscribers || []).forEach(function(fn) {
            try { fn(); } catch (e) { /* noop */ }
        });
        self._unsubscribers = [];

        // Tear down the product form view (own Backbone events + submit listener).
        if (self._productFormView && typeof self._productFormView.destroy === 'function') {
            self._productFormView.destroy();
        }
        self._productFormView = null;

        // Unslick every slider inside the detail container — media, cross-sell, etc.
        if (self.$detailContainer && self.$detailContainer.length) {
            self.$detailContainer.find('.slick-initialized').slick('unslick');
        }

        // Detach scrollToFixed bindings.
        if (self.$scrollFixingCore && self.$scrollFixingCore.length) {
            self.$scrollFixingCore.trigger('detach.ScrollToFixed');
        }
        if (self.$miniCore && self.$miniCore.length) {
            self.$miniCore.trigger('detach.ScrollToFixed');
        }

        self.undelegateEvents();
    },
    
    responsive: function () {
        var self = this;
        ORW.utilities.mediaCheck(function () {
            // Desktop actions
        }, function () {
            // Mobile actions
        })
    },
    
    isMobile: function () {
        if ( ORW.responsive == 'small') {
            return true;
        }
        return false;
    }
});